
<div class="loading-bar-container">
    <div class="loading-bar" [ngStyle]="getSuitColor" [style.width.%]="value"></div>
    <div class="loading-bar-label">{{ value  }}%</div>
</div>